import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table20Data = { [key: string]: ITable20Row };

export interface ITable20Props {
  data: Table20Data;
}

interface ITable20Row {
  crashLevelTotal: number;
  crashLevelFatal: number;
  crashLevelInjuryA: number;
  crashLevelInjuryB: number;
  crashLevelInjuryC: number;
  crashLevelPDO: number;
  personLevelFatal: number;
  personLevelInjuryA: number;
  personLevelInjuryB: number;
  personLevelInjuryC: number;
  ratesFatal: number;
  ratesInjuryA: number;
}

interface ITable20State {
}

const sortOrder = [
  "Roadway Departures",
  "Intersection",
  "Non-Motorists",
  "Young Drivers (<21)",
  "Older Drivers (>65)",
  "Impaired Driver",
  "Seat Belt Used (Ind level)",
  "Seat Belt Not Used (Ind level)",
];

export default class Table20 extends React.Component<ITable20Props, ITable20State> {
  public constructor(props: any) {
    super(props);
  };

  public render() {
    return (
      <>
        {this.props.data ?
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: '347px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '65px' }} />
              <col style={{ width: '89px' }} />
              <col style={{ width: '89px' }} />
            </colgroup>
            <thead>
              <tr>
                <th colSpan={2} rowSpan={3} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number" style={{ border: 'none' }}>20</span>
                    <div style={{ width: '3px', height: '95px', backgroundColor: 'black' }} />
                    <span className="header-text">CRITICAL EMPHASIS AREAS</span>
                  </div>
                </th>
                <th colSpan={6} className="border-right-bold">CRASH LEVEL</th>
                <th colSpan={4} className="border-right-bold">PERSON LEVEL</th>
                <th colSpan={2}>
                  RATES
                  <br />
                  (Injuries Per 100 Million Vehicle Miles)
                </th>
              </tr>
              <tr>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3}>INJURY</th>
                <th rowSpan={2} className="border-right-bold">PDO **</th>
                <th rowSpan={2}>KILLED</th>
                <th colSpan={3} className="border-right-bold">INJURY</th>
                <th rowSpan={2}>KILLED</th>
                <th rowSpan={2}>A*</th>
              </tr>
              <tr>
                <th>A*</th>
                <th>B*</th>
                <th>C*</th>
                <th>A*</th>
                <th>B*</th>
                <th className="border-right-bold">C*</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key}>
                  <td colSpan={2} className="border-right-bold">{key}</td>
                  {key.startsWith('Seat Belt') ?
                    <td className="numberTotals" style={{ backgroundColor: 'darkgray' }}></td>
                    :
                    <td className="numberTotals">{this.props.data[key].crashLevelTotal}</td>
                  }
                  {key.startsWith('Seat Belt') ?
                    <td className="numberTotals" style={{ backgroundColor: 'darkgray' }}></td>
                    :
                    <td className="numberTotals">{this.props.data[key].crashLevelFatal}</td>
                  }
                  {key.startsWith('Seat Belt') ?
                    <td className="numberTotals" style={{ backgroundColor: 'darkgray' }}></td>
                    :
                    <td className="numberTotals">{this.props.data[key].crashLevelInjuryA}</td>
                  }
                  {key.startsWith('Seat Belt') ?
                    <td className="numberTotals" style={{ backgroundColor: 'darkgray' }}></td>
                    :
                    <td className="numberTotals">{this.props.data[key].crashLevelInjuryB}</td>
                  }
                  {key.startsWith('Seat Belt') ?
                    <td className="numberTotals" style={{ backgroundColor: 'darkgray' }}></td>
                    :
                    <td className="numberTotals">{this.props.data[key].crashLevelInjuryC}</td>
                  }
                  {key.startsWith('Seat Belt') ?
                    <td className="numberTotals border-right-bold" style={{ backgroundColor: 'darkgray' }}></td>
                    :
                    <td className="numberTotals border-right-bold">{this.props.data[key].crashLevelPDO}</td>
                  }
                  <td className="numberTotals">{this.props.data[key].personLevelFatal}</td>
                  <td className="numberTotals">{this.props.data[key].personLevelInjuryA}</td>
                  <td className="numberTotals">{this.props.data[key].personLevelInjuryB}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].personLevelInjuryC}</td>
                  <td className="numberTotals">{this.props.data[key].ratesFatal}</td>
                  <td className="numberTotals">{this.props.data[key].ratesInjuryA}</td>
                </tr>
              )}
            </tbody>
          </table>
          : <p>Loading...</p>}
      </>
    );
  }
}
